import { useState, useEffect } from "react";

const ACCENT = "#B24BF3";

function Prompt({ text }) {
  if (!text) return <span>...</span>;
  const parts = text.split("___");
  if (parts.length === 1) return <span>{text}</span>;
  return (
    <span>
      {parts[0]}
      <span style={{
        color: ACCENT,
        background: ACCENT + "22",
        borderRadius: "0.3rem",
        padding: "0 6px",
        margin: "0 2px",
      }}>▢▢▢</span>
      {parts[1]}
    </span>
  );
}

export default function FibbagePlayer({
  phase, question, options, result,
  myLie, myVote, myIndex,
  onSubmitLie, onSubmitVote,
  playerColor, playerName,
}) {
  const [lieInput, setLieInput] = useState("");
  const [error, setError]       = useState("");

  // Сброс поля при новом вопросе
  useEffect(() => {
    setLieInput("");
    setError("");
  }, [question?.prompt]);

  function handleLieSubmit() {
    const text = lieInput.trim();
    if (!text || text.length < 2) { setError("Напиши хоть что-нибудь!"); return; }
    setError("");
    onSubmitLie(text);
  }

  // Ожидание
  if (phase === "wait") {
    return (
      <div className="flex flex-col items-center justify-center min-h-0 flex-1 text-center px-4">
        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⏳</div>
        <p className="font-heading text-white" style={{ fontSize:"var(--fs-xl)", marginBottom: "0.5rem" }}>
          {myLie ? "Ложь отправлена!" : "Ждём остальных..."}
        </p>
        {myLie && (
          <div style={{
            background: "#1a0040", border: `2.5px solid ${ACCENT}`,
            borderRadius: "0.85rem", boxShadow: "2px 2px 0 #000",
            padding: "0.65rem 1.25rem", marginTop: "0.5rem",
          }}>
            <p className="font-heading" style={{ color: ACCENT, fontSize:"var(--fs-sm)", marginBottom: "0.2rem" }}>Твоя ложь:</p>
            <p className="font-heading text-white" style={{ fontSize:"var(--fs-lg)" }}>«{myLie}»</p>
          </div>
        )}
        <p className="font-body" style={{ color: "#555", fontSize:"var(--fs-sm)", marginTop: "1rem" }}>Смотри на большой экран</p>
      </div>
    );
  }

  // Ввод лжи
  if (phase === "lie") {
    // Уже ответил — показываем ожидание
    if (myLie) {
      return (
        <div className="flex flex-col items-center justify-center min-h-0 flex-1 text-center px-4">
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✅</div>
          <p className="font-heading text-white" style={{ fontSize:"var(--fs-xl)", marginBottom: "0.5rem" }}>Ложь отправлена!</p>
          <div style={{
            background: "#1a0040", border: `2.5px solid ${ACCENT}`,
            borderRadius: "0.85rem", boxShadow: "2px 2px 0 #000",
            padding: "0.65rem 1.25rem", marginTop: "0.5rem",
          }}>
            <p className="font-heading" style={{ color: ACCENT, fontSize:"var(--fs-sm)", marginBottom: "0.2rem" }}>Твоя ложь:</p>
            <p className="font-heading text-white" style={{ fontSize:"var(--fs-lg)" }}>«{myLie}»</p>
          </div>
          <p className="font-body" style={{ color: "#555", fontSize:"var(--fs-sm)", marginTop: "1rem" }}>Смотри на большой экран</p>
        </div>
      );
    }

    return (
      <div className="flex flex-col items-center justify-center min-h-0 flex-1 text-center px-4">
        <div style={{
          background: "#1a0040", border: "3px solid #000",
          borderRadius: "1.25rem", boxShadow: "4px 4px 0 #000",
          padding: "1rem 1.25rem", marginBottom: "1.25rem",
          maxWidth: "360px", width: "100%",
        }}>
          <div style={{ fontSize:"var(--fs-xs)", color: ACCENT, marginBottom: "0.4rem", fontFamily:"'Fredoka One',sans-serif" }}>
            🤥 Придумай убедительную ложь
          </div>
          <p className="font-heading text-white" style={{ fontSize:"var(--fs-lg)", lineHeight: 1.45 }}>
            <Prompt text={question?.prompt} />
          </p>
        </div>

        <p className="font-body" style={{ color: "#888", fontSize:"var(--fs-sm)", marginBottom: "1rem" }}>
          Чем правдоподобнее — тем больше очков! 💰
        </p>

        <div style={{ width: "100%", maxWidth: "360px" }}>
          <input
            type="text"
            value={lieInput}
            onChange={e => { setLieInput(e.target.value); setError(""); }}
            onKeyDown={e => e.key === "Enter" && handleLieSubmit()}
            placeholder="Введи свою ложь..."
            maxLength={80}
            autoFocus
            style={{
              width: "100%", boxSizing: "border-box",
              background: "#0d0520",
              border: `2.5px solid ${error ? "#ff3355" : ACCENT + "66"}`,
              borderRadius: "0.75rem", color: "#fff",
              padding:"var(--pad-sm) var(--pad-md)", fontSize:"var(--fs-md)",
              fontFamily: "'Nunito', sans-serif", outline: "none",
              marginBottom: "0.5rem",
            }}
          />
          {error && (
            <p style={{ color: "#ff3355", fontSize:"var(--fs-sm)", marginBottom: "0.5rem", fontFamily:"'Nunito',sans-serif" }}>
              {error}
            </p>
          )}
          <button
            onClick={handleLieSubmit}
            disabled={!lieInput.trim()}
            className="btn-cartoon"
            style={{
              width: "100%", background: lieInput.trim() ? ACCENT : "#333",
              color: "#fff", fontSize:"var(--fs-lg)", padding: "0.75rem",
              opacity: lieInput.trim() ? 1 : 0.5,
            }}
          >
            Отправить ложь 🤥
          </button>
          <p style={{ color: "#444", fontSize:"var(--fs-xs)", marginTop: "0.4rem", fontFamily:"'Nunito',sans-serif" }}>
            {lieInput.length}/80
          </p>
        </div>
      </div>
    );
  }

  // Голосование
  if (phase === "vote") {
    if (myVote !== null && myVote !== undefined) {
      return (
        <div className="flex flex-col items-center justify-center min-h-0 flex-1 text-center px-4">
          <div style={{ fontSize:"var(--fs-3xl)", marginBottom: "0.5rem" }}>✅</div>
          <p className="font-heading text-white" style={{ fontSize:"var(--fs-xl)" }}>Голос отдан!</p>
          <p className="font-body" style={{ color: "#555", fontSize:"var(--fs-sm)", marginTop: "0.5rem" }}>Смотри на большой экран</p>
        </div>
      );
    }

    return (
      <div className="flex flex-col items-center justify-center min-h-0 flex-1 text-center px-4">
        <div style={{ fontSize:"var(--fs-sm)", color: ACCENT, marginBottom: "0.75rem", fontFamily: "'Fredoka One',sans-serif" }}>
          Где правда? Угадай!
        </div>
        <div style={{ width: "100%", maxWidth: "360px", display: "flex", flexDirection: "column", gap:"var(--gap-md)" }}>
          {(options || []).map((opt, i) => {
            const isMyLie = opt.index === myIndex;
            return (
              <button
                key={i}
                onClick={() => !isMyLie && onSubmitVote(opt.index)}
                disabled={isMyLie}
                style={{
                  width: "100%",
                  background: isMyLie ? "#111" : "#1a0040",
                  border: `2.5px solid ${isMyLie ? "#333" : ACCENT + "55"}`,
                  borderRadius: "0.85rem",
                  boxShadow: isMyLie ? "none" : "3px 3px 0 #000",
                  padding:"var(--pad-sm) var(--pad-md)",
                  display: "flex", alignItems: "center", gap: "0.75rem",
                  cursor: isMyLie ? "not-allowed" : "pointer",
                  textAlign: "left", transition: "all 0.1s",
                  opacity: isMyLie ? 0.4 : 1,
                }}
                onMouseEnter={e => { if (!isMyLie) { e.currentTarget.style.borderColor = ACCENT; e.currentTarget.style.background = "#2a0060"; }}}
                onMouseLeave={e => { if (!isMyLie) { e.currentTarget.style.borderColor = ACCENT + "55"; e.currentTarget.style.background = "#1a0040"; }}}
              >
                <span className="font-display" style={{ color: isMyLie ? "#555" : ACCENT, fontSize:"var(--fs-xl)", minWidth: "1.5rem" }}>
                  {i + 1}
                </span>
                <span className="font-heading" style={{ color: isMyLie ? "#555" : "#fff", fontSize:"var(--fs-md)", flex: 1, lineHeight: 1.4 }}>
                  {opt.text}
                </span>
                {isMyLie && <span style={{ fontSize:"var(--fs-xs)", color: "#555", fontFamily: "'Nunito',sans-serif" }}>твой</span>}
              </button>
            );
          })}
          <p className="font-body" style={{ color: "#555", fontSize:"var(--fs-xs)", marginTop: "0.25rem" }}>
            Нельзя голосовать за свой вариант
          </p>
        </div>
      </div>
    );
  }

  // Результат раунда
  if (phase === "result" && result) {
    const myScore    = result.scores?.[playerName] || 0;
    const guessed    = result.truth_guessers?.includes(playerName);
    const myLieFools = (result.options || []).find(o => o.author === playerName)?.vote_count || 0;
    const nobody     = result.nobody_guessed;

    let message = "Эх, мимо... 😅";
    let emoji   = "😅";
    if (guessed && myLieFools > 0) {
      message = `Угадал (+500) и обманул ${myLieFools} игрока (+${myLieFools * 300})! 🏆`;
      emoji   = "🏆";
    } else if (guessed) {
      message = "Угадал правду! +500 🎉";
      emoji   = "🎉";
    } else if (myLieFools > 0) {
      message = `Тебе поверили ${myLieFools}! +${myLieFools * 300} 😈`;
      emoji   = "😈";
    } else if (nobody) {
      message = "Никто не угадал! Бонус +200 🤡";
      emoji   = "🤡";
    }

    return (
      <div className="flex flex-col items-center justify-center min-h-0 flex-1 text-center px-4">
        <div style={{ fontSize:"var(--fs-3xl)", marginBottom: "0.5rem" }}>{emoji}</div>
        <p className="font-heading text-white" style={{ fontSize:"var(--fs-lg)", marginBottom: "1rem", lineHeight: 1.4 }}>
          {message}
        </p>
        <div style={{
          background: "#1a0040",
          border: `2.5px solid ${playerColor || ACCENT}`,
          borderRadius: "0.85rem", padding: "0.75rem 1.5rem",
          boxShadow: "3px 3px 0 #000",
        }}>
          <p className="font-heading" style={{ color: playerColor || ACCENT, fontSize:"var(--fs-sm)", marginBottom: "0.25rem" }}>Твои очки</p>
          <p className="font-display" style={{ fontSize:"var(--fs-3xl)", color: "#fff" }}>{myScore}</p>
        </div>
        <p className="font-body" style={{ color: "#555", fontSize:"var(--fs-sm)", marginTop: "1rem" }}>Смотри на большой экран</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-0 flex-1">
      <div style={{ fontSize:"var(--fs-3xl)" }}>⏳</div>
      <p className="font-body" style={{ color: "#555", marginTop: "0.5rem" }}>Ждём...</p>
    </div>
  );
}